var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9986,
    cy: 69.9927,
    r: 57.7193,
    fill: "#DB5F5F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.082 73.6739C139.085 73.7281 139.945 72.9585 139.973 71.9542C140.411 56.281 135.573 40.9118 126.235 28.3157C125.637 27.5087 124.492 27.3703 123.7 27.9893C122.909 28.6083 122.772 29.7503 123.369 30.5583C132.165 42.4601 136.731 56.9637 136.339 71.7581C136.312 72.7624 137.079 73.6198 138.082 73.6739Z",
    fill: "#DB5F5F",
    fillOpacity: 0.29
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.211 21.7888C118.922 21.0784 118.923 19.9247 118.195 19.233C110.432 11.8642 101.083 6.37319 90.8674 3.18269C89.9084 2.88321 88.9015 3.44645 88.6271 4.41287C88.3526 5.3793 88.9145 6.38281 89.8731 6.68367C99.493 9.70301 108.299 14.8751 115.621 21.8065C116.351 22.4972 117.501 22.4992 118.211 21.7888Z",
    fill: "#DB5F5F",
    fillOpacity: 0.29
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3999 2.47015C79.5384 1.47509 78.8442 0.553691 77.8459 0.441085C70.2424 -0.416554 62.5495 -0.0217138 55.0738 1.60988C54.0923 1.8241 53.496 2.81173 53.7357 3.78738C53.9754 4.76302 54.9601 5.35708 55.942 5.14426C62.9693 3.62101 70.1977 3.25 77.3441 4.04577C78.3426 4.15696 79.2614 3.4652 79.3999 2.47015Z",
    fill: "#DB5F5F",
    fillOpacity: 0.29
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3528 5.69027C47.0191 4.74267 45.9794 4.24272 45.0408 4.60094C42.1024 5.72236 39.2429 7.04054 36.4818 8.54652C35.5998 9.02758 35.3047 10.1428 35.8085 11.012C36.3124 11.8812 37.4242 12.1751 38.3069 11.6953C40.8711 10.3014 43.5245 9.07825 46.2497 8.03373C47.1878 7.67418 47.6865 6.63788 47.3528 5.69027Z",
    fill: "#DB5F5F",
    fillOpacity: 0.29
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3019 15.2981C28.7022 14.492 27.5611 14.3228 26.7709 14.9433C26.0843 15.4824 25.4078 16.0343 24.7419 16.5987C23.9755 17.2482 23.9121 18.4001 24.5814 19.1494C25.2506 19.8986 26.3989 19.9615 27.1663 19.313C27.7502 18.8196 28.3427 18.3362 28.9433 17.8632C29.7326 17.2416 29.9016 16.1041 29.3019 15.2981Z",
    fill: "#DB5F5F",
    fillOpacity: 0.29
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82.002L82 58.002M58 58.002L82 82.002",
    stroke: "white",
    strokeWidth: 8.61539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.2982b22bab2b3d66c3d25ccf02bfca46.svg";
export { ForwardRef as ReactComponent };